import { render, staticRenderFns } from "./KpiProduccion.vue?vue&type=template&id=7ef8aae4&scoped=true"
import script from "./KpiProduccion.vue?vue&type=script&lang=js"
export * from "./KpiProduccion.vue?vue&type=script&lang=js"
import style0 from "./KpiProduccion.vue?vue&type=style&index=0&id=7ef8aae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef8aae4",
  null
  
)

export default component.exports